import type { IconProps } from './types';

export const LogoPictogramIcon: React.FC<IconProps> = (props) => {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18V36H18C8.05888 36 0 27.9411 0 18ZM7 18C7 11.9249 11.9249 7 18 7C24.0751 7 29 11.9249 29 18V22H22V29H18C11.9249 29 7 24.0751 7 18Z"
                fill="currentColor"
            />
        </svg>
    );
};
